export const LOGOUT = 'LOGOUT'
export const SET_ERROR = 'SET_ERROR'

export const BSRS_LOGIN_REQUEST = 'BSRS_LOGIN_REQUEST'
export const BSRS_LOGIN_SUCCESS = 'BSRS_LOGIN_SUCCESS'
export const BSRS_LOGIN_FAILURE = 'BSRS_LOGIN_FAILURE'

export const CORE_LOAD_ORDER_DETAIL_REQUEST = 'CORE_LOAD_ORDER_DETAIL_REQUEST'
export const CORE_LOAD_ORDER_DETAIL_SUCCESS = 'CORE_LOAD_ORDER_DETAIL_SUCCESS'
export const CORE_LOAD_ORDER_DETAIL_FAILURE = 'CORE_LOAD_ORDER_DETAIL_FAILURE'

export const CORE_CHANGE_ORDER_AMOUNT = 'CORE_CHANGE_ORDER_AMOUNT'

export const CORE_UPSERT_ORDERS_REQUEST = 'CORE_UPSERT_ORDERS_REQUEST'
export const CORE_UPSERT_ORDERS_SUCCESS = 'CORE_UPSERT_ORDERS_SUCCESS'
export const CORE_UPSERT_ORDERS_FAILURE = 'CORE_UPSERT_ORDERS_FAILURE'

export const CORE_LOAD_CHEKIN_REQUEST = 'CORE_LOAD_CHEKIN_REQUEST'
export const CORE_LOAD_CHEKIN_SUCCESS = 'CORE_LOAD_CHEKIN_SUCCESS'
export const CORE_LOAD_CHEKIN_FAILURE = 'CORE_LOAD_CHEKIN_FAILURE'

export const CORE_CREATE_CHECKIN_REQUEST = 'CORE_CREATE_CHECKIN_REQUEST'
export const CORE_CREATE_CHECKIN_SUCCESS = 'CORE_CREATE_CHECKIN_SUCCESS'
export const CORE_CREATE_CHECKIN_FAILURE = 'CORE_CREATE_CHECKIN_FAILURE'

export const CORE_SEARCH_ROOMS_REQUEST = 'CORE_SEARCH_ROOMS_REQUEST'
export const CORE_SEARCH_ROOMS_SUCCESS = 'CORE_SEARCH_ROOMS_SUCCESS'
export const CORE_SEARCH_ROOMS_FAILURE = 'CORE_SEARCH_ROOMS_FAILURE'
export const CORE_ROOMS_CLEAR = 'CORE_ROOMS_CLEAR'

export const CORE_LOAD_ROOMS_REQUEST = 'CORE_LOAD_ROOMS_REQUEST'
export const CORE_LOAD_ROOMS_SUCCESS = 'CORE_LOAD_ROOMS_SUCCESS'
export const CORE_LOAD_ROOMS_FAILURE = 'CORE_LOAD_ROOMS_FAILURE'

export const CORE_LOAD_ROOMS_SUGGEST_REQUEST = 'CORE_LOAD_ROOMS_SUGGEST_REQUEST'
export const CORE_LOAD_ROOMS_SUGGEST_SUCCESS = 'CORE_LOAD_ROOMS_SUGGEST_SUCCESS'
export const CORE_LOAD_ROOMS_SUGGEST_FAILURE = 'CORE_LOAD_ROOMS_SUGGEST_FAILURE'

export const CORE_LOAD_ROOMS_FIRST_SUGGEST_REQUEST = 'CORE_LOAD_ROOMS_FIRST_SUGGEST_REQUEST'
export const CORE_LOAD_ROOMS_FIRST_SUGGEST_SUCCESS = 'CORE_LOAD_ROOMS_FIRST_SUGGEST_SUCCESS'
export const CORE_LOAD_ROOMS_FIRST_SUGGEST_FAILURE = 'CORE_LOAD_ROOMS_FIRST_SUGGEST_FAILURE'

export const CORE_LOAD_SLOTS_REQUEST = 'CORE_LOAD_SLOTS_REQUEST'
export const CORE_LOAD_SLOTS_SUCCESS = 'CORE_LOAD_SLOTS_SUCCESS'
export const CORE_LOAD_SLOTS_FAILURE = 'CORE_LOAD_SLOTS_FAILURE'

export const CORE_LOAD_FLOORS_REQUEST = 'CORE_LOAD_FLOORS_REQUEST'
export const CORE_LOAD_FLOORS_SUCCESS = 'CORE_LOAD_FLOORS_SUCCESS'
export const CORE_LOAD_FLOORS_FAILURE = 'CORE_LOAD_FLOORS_FAILURE'

export const CORE_LOAD_FLOOR_INFO_REQUEST = 'CORE_LOAD_FLOOR_INFO_REQUEST'
export const CORE_LOAD_FLOOR_INFO_SUCCESS = 'CORE_LOAD_FLOOR_INFO_SUCCESS'
export const CORE_LOAD_FLOOR_INFO_FAILURE = 'CORE_LOAD_FLOOR_INFO_FAILURE'

export const CORE_LOAD_AMENITIES_REQUEST = 'CORE_LOAD_AMENITIES_REQUEST'
export const CORE_LOAD_AMENITIES_SUCCESS = 'CORE_LOAD_AMENITIES_SUCCESS'
export const CORE_LOAD_AMENITIES_FAILURE = 'CORE_LOAD_AMENITIES_FAILURE'

export const CORE_LOAD_USERS_REQUEST = 'CORE_LOAD_USERS_REQUEST'
export const CORE_LOAD_USERS_SUCCESS = 'CORE_LOAD_USERS_SUCCESS'
export const CORE_LOAD_USERS_FAILURE = 'CORE_LOAD_USERS_FAILURE'

export const CORE_LOAD_USER_INFO_REQUEST = 'CORE_LOAD_USER_INFO_REQUEST'
export const CORE_LOAD_USER_INFO_SUCCESS = 'CORE_LOAD_USER_INFO_SUCCESS'
export const CORE_LOAD_USER_INFO_FAILURE = 'CORE_LOAD_USER_INFO_FAILURE'

export const CORE_LOAD_ROOMINFO_REQUEST = 'CORE_LOAD_ROOMINFO_REQUEST'
export const CORE_LOAD_ROOMINFO_SUCCESS = 'CORE_LOAD_ROOMINFO_SUCCESS'
export const CORE_LOAD_ROOMINFO_FAILURE = 'CORE_LOAD_ROOMINFO_FAILURE'

export const LOAD_ROOMINFO_REQUEST = 'LOAD_ROOMINFO_REQUEST'
export const LOAD_ROOMINFO_SUCCESS = 'LOAD_ROOMINFO_SUCCESS'
export const LOAD_ROOMINFO_FAILURE = 'LOAD_ROOMINFO_FAILURE'

export const CORE_CREATE_EVENT_REQUEST = 'CORE_CREATE_EVENT_REQUEST'
export const CORE_CREATE_EVENT_SUCCESS = 'CORE_CREATE_EVENT_SUCCESS'
export const CORE_CREATE_EVENT_FAILURE = 'CORE_CREATE_EVENT_FAILURE'

export const CORE_EDIT_EVENT_REQUEST = 'CORE_EDIT_EVENT_REQUEST'
export const CORE_EDIT_EVENT_SUCCESS = 'CORE_EDIT_EVENT_SUCCESS'
export const CORE_EDIT_EVENT_FAILURE = 'CORE_EDIT_EVENT_FAILURE'

export const CORE_DELETE_EVENT_REQUEST = 'CORE_DELETE_EVENT_REQUEST'
export const CORE_DELETE_EVENT_SUCCESS = 'CORE_DELETE_EVENT_SUCCESS'
export const CORE_DELETE_EVENT_FAILURE = 'CORE_DELETE_EVENT_FAILURE'

export const CORE_DELETE_EVENT_RECURRENCE_REQUEST = 'CORE_DELETE_EVENT_RECURRENCE_REQUEST'
export const CORE_DELETE_EVENT_RECURRENCE_SUCCESS = 'CORE_DELETE_EVENT_RECURRENCE_SUCCESS'
export const CORE_DELETE_EVENT_RECURRENCE_FAILURE = 'CORE_DELETE_EVENT_RECURRENCE_FAILURE'

export const CORE_LOAD_EVENTINFO_REQUEST = 'CORE_LOAD_EVENTINFO_REQUEST'
export const CORE_LOAD_EVENTINFO_SUCCESS = 'CORE_LOAD_EVENTINFO_SUCCESS'
export const CORE_LOAD_EVENTINFO_FAILURE = 'CORE_LOAD_EVENTINFO_FAILURE'

export const CORE_LOAD_EVENTINCOMING_REQUEST = 'CORE_LOAD_EVENTINCOMING_REQUEST'
export const CORE_LOAD_EVENTINCOMING_SUCCESS = 'CORE_LOAD_EVENTINCOMING_SUCCESS'
export const CORE_LOAD_EVENTINCOMING_FAILURE = 'CORE_LOAD_EVENTINCOMING_FAILURE'

export const CORE_LOAD_EVENTHISTORY_REQUEST = 'CORE_LOAD_EVENTHISTORY_REQUEST'
export const CORE_LOAD_EVENTHISTORY_SUCCESS = 'CORE_LOAD_EVENTHISTORY_SUCCESS'
export const CORE_LOAD_EVENTHISTORY_FAILURE = 'CORE_LOAD_EVENTHISTORY_FAILURE'

export const CORE_VERIFY_BYPASS_REQUEST = 'CORE_VERIFY_BYPASS_REQUEST'
export const CORE_VERIFY_BYPASS_SUCCESS = 'CORE_VERIFY_BYPASS_SUCCESS'
export const CORE_VERIFY_BYPASS_FAILURE = 'CORE_VERIFY_BYPASS_FAILURE'

export const CORE_ACCEPT_TERM_REQUEST = 'CORE_ACCEPT_TERM_REQUEST'
export const CORE_ACCEPT_TERM_SUCCESS = 'CORE_ACCEPT_TERM_SUCCESS'
export const CORE_ACCEPT_TERM_FAILURE = 'CORE_ACCEPT_TERM_FAILURE'

export const CORE_CHECKIN_REQUEST = 'CORE_CHECKIN_REQUEST'
export const CORE_CHECKIN_SUCCESS = 'CORE_CHECKIN_SUCCESS'
export const CORE_CHECKIN_FAILURE = 'CORE_CHECKIN_FAILURE'

export const CORE_LOAD_EVENTCALENDAR_REQUEST = 'CORE_LOAD_EVENTCALENDAR_REQUEST'
export const CORE_LOAD_EVENTCALENDAR_SUCCESS = 'CORE_LOAD_EVENTCALENDAR_SUCCESS'
export const CORE_LOAD_EVENTCALENDAR_FAILURE = 'CORE_LOAD_EVENTCALENDAR_FAILURE'

export const CORE_LOAD_AMENITYACTIVE_REQUEST = 'CORE_LOAD_AMENITYACTIVE_REQUEST'
export const CORE_LOAD_AMENITYACTIVE_SUCCESS = 'CORE_LOAD_AMENITYACTIVE_SUCCESS'
export const CORE_LOAD_AMENITYACTIVE_FAILURE = 'CORE_LOAD_AMENITYACTIVE_FAILURE'

export const CORE_LOAD_ORDERS_REQUEST = 'CORE_LOAD_ORDERS_REQUEST'
export const CORE_LOAD_ORDERS_SUCCESS = 'CORE_LOAD_ORDERS_SUCCESS'
export const CORE_LOAD_ORDERS_FAILURE = 'CORE_LOAD_ORDERS_FAILURE'

export const CORE_LOAD_AMENITYPAST_REQUEST = 'CORE_LOAD_AMENITYPAST_REQUEST'
export const CORE_LOAD_AMENITYPAST_SUCCESS = 'CORE_LOAD_AMENITYPAST_SUCCESS'
export const CORE_LOAD_AMENITYPAST_FAILURE = 'CORE_LOAD_AMENITYPAST_FAILURE'

export const CORE_LOAD_AMENITYNEXT_REQUEST = 'CORE_LOAD_AMENITYNEXT_REQUEST'
export const CORE_LOAD_AMENITYNEXT_SUCCESS = 'CORE_LOAD_AMENITYNEXT_SUCCESS'
export const CORE_LOAD_AMENITYNEXT_FAILURE = 'CORE_LOAD_AMENITYNEXT_FAILURE'

export const CORE_LOAD_FOODS_REQUEST = 'CORE_LOAD_FOODS_REQUEST'
export const CORE_LOAD_FOODS_SUCCESS = 'CORE_LOAD_FOODS_SUCCESS'
export const CORE_LOAD_FOODS_FAILURE = 'CORE_LOAD_FOODS_FAILURE'

export const CORE_LOAD_SERVICEACTIVE_REQUEST = 'CORE_LOAD_SERVICEACTIVE_REQUEST'
export const CORE_LOAD_SERVICEACTIVE_SUCCESS = 'CORE_LOAD_SERVICEACTIVE_SUCCESS'
export const CORE_LOAD_SERVICEACTIVE_FAILURE = 'CORE_LOAD_SERVICEACTIVE_FAILURE'

export const CORE_LOAD_SERVICEPAST_REQUEST = 'CORE_LOAD_SERVICEPAST_REQUEST'
export const CORE_LOAD_SERVICEPAST_SUCCESS = 'CORE_LOAD_SERVICEPAST_SUCCESS'
export const CORE_LOAD_SERVICEPAST_FAILURE = 'CORE_LOAD_SERVICEPAST_FAILURE'

export const CORE_DELETE_ORDER_REQUEST = 'CORE_DELETE_ORDER_REQUEST'
export const CORE_DELETE_ORDER_SUCCESS = 'CORE_DELETE_ORDER_SUCCESS'
export const CORE_DELETE_ORDER_FAILURE = 'CORE_DELETE_ORDER_FAILURE'

export const CORE_SENDAMENITY_REQUEST = 'CORE_SENDAMENITY_REQUEST'
export const CORE_SENDAMENITY_SUCCESS = 'CORE_SENDAMENITY_SUCCESS'
export const CORE_SENDAMENITY_FAILURE = 'CORE_SENDAMENITY_FAILURE'

export const CORE_SENDFOOD_REQUEST = 'CORE_SENDFOOD_REQUEST'
export const CORE_SENDFOOD_SUCCESS = 'CORE_SENDFOOD_SUCCESS'
export const CORE_SENDFOOD_FAILURE = 'CORE_SENDFOOD_FAILURE'

export const CORE_LOAD_FOODACTIVE_REQUEST = 'CORE_LOAD_FOODACTIVE_REQUEST'
export const CORE_LOAD_FOODACTIVE_SUCCESS = 'CORE_LOAD_FOODACTIVE_SUCCESS'
export const CORE_LOAD_FOODACTIVE_FAILURE = 'CORE_LOAD_FOODACTIVE_FAILURE'

export const CORE_LOAD_FOODPAST_REQUEST = 'CORE_LOAD_FOODPAST_REQUEST'
export const CORE_LOAD_FOODPAST_SUCCESS = 'CORE_LOAD_FOODPAST_SUCCESS'
export const CORE_LOAD_FOODPAST_FAILURE = 'CORE_LOAD_FOODPAST_FAILURE'

export const CORE_LOAD_FOODNEXT_REQUEST = 'CORE_LOAD_FOODNEXT_REQUEST'
export const CORE_LOAD_FOODNEXT_SUCCESS = 'CORE_LOAD_FOODNEXT_SUCCESS'
export const CORE_LOAD_FOODNEXT_FAILURE = 'CORE_LOAD_FOODNEXT_FAILURE'

export const CORE_DONEAMENITY_REQUEST = 'CORE_DONEAMENITY_REQUEST'
export const CORE_DONEAMENITY_SUCCESS = 'CORE_DONEAMENITY_SUCCESS'
export const CORE_DONEAMENITY_FAILURE = 'CORE_DONEAMENITY_FAILURE'

export const CORE_DONEFOOD_REQUEST = 'CORE_DONEFOOD_REQUEST'
export const CORE_DONEFOOD_SUCCESS = 'CORE_DONEFOOD_SUCCESS'
export const CORE_DONEFOOD_FAILURE = 'CORE_DONEFOOD_FAILURE'

export const CORE_CANCELEVENTAMENITY_REQUEST = 'CORE_CANCELEVENTAMENITY_REQUEST'
export const CORE_CANCELEVENTAMENITY_SUCCESS = 'CORE_CANCELEVENTAMENITY_SUCCESS'
export const CORE_CANCELEVENTAMENITY_FAILURE = 'CORE_CANCELEVENTAMENITY_FAILURE'

export const CORE_CANCELEVENTFOOD_REQUEST = 'CORE_CANCELEVENTFOOD_REQUEST'
export const CORE_CANCELEVENTFOOD_SUCCESS = 'CORE_CANCELEVENTFOOD_SUCCESS'
export const CORE_CANCELEVENTFOOD_FAILURE = 'CORE_CANCELEVENTFOOD_FAILURE'
export const CORE_CREATE_ORDER_REQUEST = 'CORE_CREATE_ORDER_REQUEST'
export const CORE_CREATE_ORDER_SUCCESS = 'CORE_CREATE_ORDER_SUCCESS'
export const CORE_CREATE_ORDER_FAILURE = 'CORE_CREATE_ORDER_FAILURE'

export const CORE_LOAD_ORDER_INFO_REQUEST = 'CORE_LOAD_ORDER_INFO_REQUEST'
export const CORE_LOAD_ORDER_INFO_SUCCESS = 'CORE_LOAD_ORDER_INFO_SUCCESS'
export const CORE_LOAD_ORDER_INFO_FAILURE = 'CORE_LOAD_ORDER_INFO_FAILURE'

export const CORE_EDIT_ORDER_REQUEST = 'CORE_EDIT_ORDER_REQUEST'
export const CORE_EDIT_ORDER_SUCCESS = 'CORE_EDIT_ORDER_SUCCESS'
export const CORE_EDIT_ORDER_FAILURE = 'CORE_EDIT_ORDER_FAILURE'

export const CORE_LOAD_LAST_USERS_REQUEST = 'CORE_LOAD_LAST_USERS_REQUEST'
export const CORE_LOAD_LAST_USERS_SUCCESS = 'CORE_LOAD_LAST_USERS_SUCCESS'
export const CORE_LOAD_LAST_USERS_FAILURE = 'CORE_LOAD_LAST_USERS_FAILURE'

export const CORE_LOAD_EVENT_LOG_TITLE_REQUEST = 'CORE_LOAD_EVENT_LOG_TITLE_REQUEST'
export const CORE_LOAD_EVENT_LOG_TITLE_SUCCESS = 'CORE_LOAD_EVENT_LOG_TITLE_SUCCESS'
export const CORE_LOAD_EVENT_LOG_TITLE_FAILURE = 'CORE_LOAD_EVENT_LOG_TITLE_FAILURE'

export const CORE_CREATE_EVENT_LOG_REQUEST = 'CORE_CREATE_EVENT_LOG_REQUEST'
export const CORE_CREATE_EVENT_LOG_SUCCESS = 'CORE_CREATE_EVENT_LOG_SUCCESS'
export const CORE_CREATE_EVENT_LOG_FAILURE = 'CORE_CREATE_EVENT_LOG_FAILURE'

export const CORE_SCANQR_REQUEST = 'CORE_SCANQR_REQUEST'
export const CORE_SCANQR_SUCCESS = 'CORE_SCANQR_SUCCESS'
export const CORE_SCANQR_FAILURE = 'CORE_SCANQR_FAILURE'

export const CORE_LOAD_ROOM_FORMAT_REQUEST = 'CORE_LOAD_ROOM_FORMAT_REQUEST'
export const CORE_LOAD_ROOM_FORMAT_SUCCESS = 'CORE_LOAD_ROOM_FORMAT_SUCCESS'
export const CORE_LOAD_ROOM_FORMAT_FAILURE = 'CORE_LOAD_ROOM_FORMAT_FAILURE'

export const CORE_LOAD_EVENTSERVICEAMENITY_REQUEST = 'CORE_LOAD_EVENTSERVICEAMENITY_REQUEST'
export const CORE_LOAD_EVENTSERVICEAMENITY_SUCCESS = 'CORE_LOAD_EVENTSERVICEAMENITY_SUCCESS'
export const CORE_LOAD_EVENTSERVICEAMENITY_FAILURE = 'CORE_LOAD_EVENTSERVICEAMENITY_FAILURE'

export const CORE_LOAD_EVENTSERVICEFBS_REQUEST = 'LOAD_EVENTSERVICEFBS_REQUEST'
export const CORE_LOAD_EVENTSERVICEFBS_SUCCESS = 'LOAD_EVENTSERVICEFBS_SUCCESS'
export const CORE_LOAD_EVENTSERVICEFBS_FAILURE = 'LOAD_EVENTSERVICEFBS_FAILURE'

export const CORE_LOAD_ROOM_TYPE_REQUEST = 'CORE_LOAD_ROOM_TYPE_REQUEST'
export const CORE_LOAD_ROOM_TYPE_SUCCESS = 'CORE_LOAD_ROOM_TYPE_SUCCESS'
export const CORE_LOAD_ROOM_TYPE_FAILURE = 'CORE_LOAD_ROOM_TYPE_FAILURE'

export const CORE_LOAD_EVENTINFOSERVICE_REQUEST = 'CORE_LOAD_EVENTINFOSERVICE_REQUEST'
export const CORE_LOAD_EVENTINFOSERVICE_SUCCESS = 'CORE_LOAD_EVENTINFOSERVICE_SUCCESS'
export const CORE_LOAD_EVENTINFOSERVICE_FAILURE = 'CORE_LOAD_EVENTINFOSERVICE_FAILURE'

export const CORE_SAVE_FORMSUGGEST = 'CORE_SAVE_FORMSUGGEST'
export const CORE_SAVE_FORMSEARCHNAME = 'CORE_SAVE_FORMSEARCHNAME'
export const CORE_CLEAR_FORMSEARCHNAME = 'CORE_CLEAR_FORMSEARCHNAME'

export const CORE_LOAD_SETTINGS_REQUEST = 'CORE_LOAD_SETTINGS_REQUEST'
export const CORE_LOAD_SETTINGS_SUCCESS = 'CORE_LOAD_SETTINGS_SUCCESS'
export const CORE_LOAD_SETTINGS_FAILURE = 'CORE_LOAD_SETTINGS_FAILURE'

export const CORE_VERIFY_LOGIN_REQUEST = 'CORE_VERIFY_LOGIN_REQUEST'
export const CORE_VERIFY_LOGIN_SUCCESS = 'CORE_VERIFY_LOGIN_SUCCESS'
export const CORE_VERIFY_LOGIN_FAILURE = 'CORE_VERIFY_LOGIN_FAILURE'

export const CORE_SEND_REPORT_REQUEST = 'CORE_SEND_REPORT_REQUEST'
export const CORE_SEND_REPORT_SUCCESS = 'CORE_SEND_REPORT_SUCCESS'
export const CORE_SEND_REPORT_FAILURE = 'CORE_SEND_REPORT_FAILURE'

export const CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST = 'CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST'
export const CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS = 'CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS'
export const CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE = 'CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE'

export const CORE_CHANGE_PASSWORD_REQUEST = 'CORE_CHANGE_PASSWORD_REQUEST'
export const CORE_CHANGE_PASSWORD_SUCCESS = 'CORE_CHANGE_PASSWORD_SUCCESS'
export const CORE_CHANGE_PASSWORD_FAILURE = 'CORE_CHANGE_PASSWORD_FAILURE'

export const CORE_FIRST_CHANGE_PASSWORD_REQUEST = 'CORE_FIRST_CHANGE_PASSWORD_REQUEST'
export const CORE_FIRST_CHANGE_PASSWORD_SUCCESS = 'CORE_FIRST_CHANGE_PASSWORD_SUCCESS'
export const CORE_FIRST_CHANGE_PASSWORD_FAILURE = 'CORE_FIRST_CHANGE_PASSWORD_FAILURE'

export const CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST = 'CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST'
export const CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS = 'CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS'
export const CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_FAILURE = 'CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_FAILURE'

export const CORE_LOAD_LOCATION_USER_REQUEST = 'CORE_LOAD_LOCATION_USER_REQUEST'
export const CORE_LOAD_LOCATION_USER_SUCCESS = 'CORE_LOAD_LOCATION_USER_SUCCESS'
export const CORE_LOAD_LOCATION_USER_FAILURE = 'CORE_LOAD_LOCATION_USER_FAILURE'

export const CORE_CHANGEROLE_FRONTEND_REQUEST = 'CORE_CHANGEROLE_FRONTEND_REQUEST'
export const CORE_CHANGEROLE_FRONTEND_SUCCESS = 'CORE_CHANGEROLE_FRONTEND_SUCCESS'
export const CORE_CHANGEROLE_FRONTEND_FAILURE = 'CORE_CHANGEROLE_FRONTEND_FAILURE'

export const CORE_LOAD_ROLESETTINGS_REQUEST = 'CORE_LOAD_ROLESETTINGS_REQUEST'
export const CORE_LOAD_ROLESETTINGS_SUCCESS = 'CORE_LOAD_ROLESETTINGS_SUCCESS'
export const CORE_LOAD_ROLESETTINGS_FAILURE = 'CORE_LOAD_ROLESETTINGS_FAILURE'

export const CORE_LOAD_ALL_EVENT_ROOM_SERVICE_REQUEST = 'CORE_LOAD_ALL_EVENT_ROOM_SERVICE_REQUEST'
export const CORE_LOAD_ALL_EVENT_ROOM_SERVICE_SUCCESS = 'CORE_LOAD_ALL_EVENT_ROOM_SERVICE_SUCCESS'
export const CORE_LOAD_ALL_EVENT_ROOM_SERVICE_FAILURE = 'CORE_LOAD_ALL_EVENT_ROOM_SERVICE_FAILURE'

export const CORE_CHANGEEMAILNOTI_FRONTEND_REQUEST = 'CORE_CHANGEEMAILNOTI_FRONTEND_REQUEST'
export const CORE_CHANGEEMAILNOTI_FRONTEND_SUCCESS = 'CORE_CHANGEEMAILNOTI_FRONTEND_SUCCESS'
export const CORE_CHANGEEMAILNOTI_FRONTEND_FAILURE = 'CORE_CHANGEEMAILNOTI_FRONTEND_FAILURE'

export const CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_REQUEST = 'CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_REQUEST'
export const CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_SUCCESS = 'CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_SUCCESS'
export const CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_FAILURE = 'CORE_LOAD_ALL_EVENT_ROOM_SERVICE_CALENDAR_FAILURE'



// WEBPACK FOOTER //
// ./src/front/types.js